import { LanguageSelector } from "./LanguageSelector";

export function PublicLanguageSelector() {
  return (
    <div
      style={{
        position: 'fixed',
        top: 20,
        right: 24,
        zIndex: 2000,
        borderRadius: 14,
        padding: 6,
        minWidth: 48,
        minHeight: 48,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <LanguageSelector size="xs"  />
    </div>
  );
}
